import React from 'react';
import Header from '@components/mobile-header';
import MagicFrame from './iframe';
import { useHideNavValue } from '@utils/hooks';
import './index.less';
import './index.h5.less';

const MagicEventh5: React.FC = () => {
    const hideNav = useHideNavValue();

    if (hideNav) {
        return (
            <div className="magic-page hide-nav">
                <MagicFrame isMobile />
            </div>
        );
    }
    return (
        <div className="magic-page">
            <Header />
            <MagicFrame isMobile />
        </div>
    );
};

export default MagicEventh5;
